import React from 'react';
import { Play, Sparkles } from 'lucide-react';
import { supabase } from '../lib/supabase';

export interface RecommendedVideo {
  video_id: string;
  video_title: string;
  youtube_url: string;
  thumbnail_url: string;
  content_id?: string;
}

interface VideoRecommendationCardProps {
  video: RecommendedVideo;
  onNavigateToVideo?: (contentId: string, videoId: string) => void;
}

export const VideoRecommendationCard: React.FC<VideoRecommendationCardProps> = ({
  video,
  onNavigateToVideo,
}) => {

  const handleWatchVideo = async () => {
    let targetContentId = video.content_id;

    // Se o content_id não veio no objeto de recomendação, busca no Supabase
    if (!targetContentId && video.video_id) {
      try {
        const { data } = await supabase
          .from('content_videos')
          .select('content_id')
          .eq('id', video.video_id)
          .single();

        if (data?.content_id) {
          targetContentId = data.content_id;
        }
      } catch (err) {
        console.warn('Alerta ao buscar content_id para navegação interna:', err);
      }
    }

    if (targetContentId && onNavigateToVideo) {
      onNavigateToVideo(targetContentId, video.video_id);
    }
  };

  return (
    <div className="my-2 p-3 bg-[#121316]/90 border border-[#0FFF55]/30 hover:border-[#0FFF55]/60 rounded-2xl transition-all duration-300 shadow-md hover:shadow-lg hover:shadow-[#0FFF55]/10 group">
      <div className="flex items-center space-x-3">
        {/* Thumbnail Container */}
        <div className="relative w-20 h-14 sm:w-24 sm:h-16 rounded-xl overflow-hidden bg-[#1a1d21] flex-shrink-0 border border-gray-800 group-hover:border-[#0FFF55]/40 transition-colors">
          {video.thumbnail_url ? (
            <img
              src={video.thumbnail_url}
              alt={video.video_title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-[#1a1d21] text-gray-500">
              <Play size={20} />
            </div>
          )}
          <button
            onClick={handleWatchVideo}
            className="absolute inset-0 bg-black/40 group-hover:bg-black/20 flex items-center justify-center transition-colors cursor-pointer"
            title="Assistir Aula no MasterClub"
          >
            <div className="w-8 h-8 rounded-full bg-[#0FFF55] text-[#121316] flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
              <Play size={14} className="fill-[#121316] ml-0.5" />
            </div>
          </button>
        </div>

        {/* Info & Action */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-1 mb-1">
            <Sparkles size={12} className="text-[#0FFF55] animate-pulse" />
            <span className="text-[10px] font-black text-[#0FFF55] uppercase tracking-wider">
              Aula Recomendada
            </span>
          </div>
          <h4 className="text-xs sm:text-sm font-bold text-white truncate group-hover:text-[#0FFF55] transition-colors">
            {video.video_title}
          </h4>
          <div className="flex items-center space-x-2 mt-2">
            <button
              onClick={handleWatchVideo}
              className="inline-flex items-center space-x-1 bg-[#0FFF55] hover:bg-[#0dd149] text-[#121316] text-xs font-bold px-3 py-1.5 rounded-lg transition-all shadow-sm hover:shadow-[#0FFF55]/20 active:scale-95 cursor-pointer"
            >
              <Play size={12} className="fill-[#121316]" />
              <span>Assistir Aula</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
